import React from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";
import $ from "jquery";
import 'jquery-ui-dist/jquery-ui';
import {isMobile} from "../../assets-static/scripts/utils";
window.jQuery = $;
require('jquery-ui-touch-punch')

class LearnMore_LightBox extends React.Component {

    static propTypes = {
        titleKey: PropTypes.string,
        contentKey: PropTypes.string,
        imagePath: PropTypes.string,
        handleOpenModal: PropTypes.func
    }

    static defaultProps = {
        titleKey: '',
        contentKey: '',
        imagePath: '',
        handleOpenModal: () => {
        }
    }

    componentDidMount() {
        $(".StaticModal-overlay").css({
            top: 0,
            left: 0,
            marginTop: 15
        });

        if (isMobile.any()) {
            $('.StaticModal-overlay').addClass('StaticModal-overlayMobile');
        }

        $(".StaticModal-overlay").draggable({
            cursor: "move",
            opacity: '.8',
            cancel: 'label, input, select, a,textarea'
        });

        $(".StaticModal-overlay").resizable();
    }

    render() {
        const {
            titleKey,
            contentKey,
            imagePath,
            handleOpenModal
        } = this.props;
        return (
            <div className="StaticModal StaticCloseableModal" style={{display: "block"}}>
                <div className="StaticModal-overlay ui-draggable ui-draggable-handle ui-resizable">
	                    <span className="StaticCloseableModal-closeContainer"
                              onClick={handleOpenModal}>
      	                    <span className="StaticCloseableModal-closeLabel">
                                <FormatMessage id="control.button.close"/>
                              </span>
                            <span className="Icon Icon-circleCrossSolid StaticCloseableModal-closeIcon"></span>
                        </span>
                    <div className="StaticModal-container">
                        <div className="InfoModal">
                            {titleKey != "" &&
                                <div className="InfoModal-title">
                                    <FormatMessage id={titleKey}/>
                                </div>
                            }
                            <div className="InfoModal-content">
                                <div className="RawHTML">
                                    <FormatMessage id={contentKey}/>
                                    {imagePath != "" &&
                                        <img src={imagePath} alt="imageName" width="538" height="235"/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LearnMore_LightBox;
